import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import FlameImg from "../../assets/images/flame.webp";
import "./index.less";

interface FreeChatButtonProps {
  onClick: () => void;
}

const FreeChatButtonComponent: React.FC<FreeChatButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isComponentMounted = useRef(true);

  useEffect(() => {
    isComponentMounted.current = true;

    const handleAnimationCycle = () => {
      if (isComponentMounted.current) {
        setIsAnimating(true);

        timeoutRef.current = setTimeout(() => {
          if (isComponentMounted.current) {
            setIsAnimating(false);

            timeoutRef.current = setTimeout(() => {
              if (isComponentMounted.current) {
                handleAnimationCycle();
              }
            }, 2000);
          }
        }, 500);
      }
    };

    handleAnimationCycle();

    return () => {
      isComponentMounted.current = false;

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div onClick={onClick} className={`free-chat-button ${isAnimating ? "animate" : ""}`}>
      <img src={FlameImg} className="free-chat-button-flame-img" alt="flame" />
      <span className="free-chat-button-text free-text">{t("free")}</span>
      <span className="free-chat-button-text free-text point"></span>
      <span className="free-chat-button-text">{t("discute")}</span>
    </div>
  );
};

export default FreeChatButtonComponent;
